// Single source of truth for whether a guard is ready to grab jobs. Used by
// the Profile screen, the Pool screen (gate the Grab button + show a banner),
// and the My Jobs screen (banner only).
//
// "Ready" means we have everything Orion / brokers will ask for in an audit:
//   - profile photo (so the rep recognizes them at pickup)
//   - phone (so rep + owner can text them)
//   - TWIC card image + expiration date (clearance proof)
//
// Tax info is excluded from this gate — it's needed for *getting paid*, not
// for clearance, and a guard can grab a first job and finish their W9 later.

export function guardReadiness(profile) {
  if (!profile) return { ready: false, missing: ["profile not loaded"] };
  const missing = [];
  if (!profile.photoUrl) missing.push("Profile photo");
  if (!profile.phone) missing.push("Phone number");
  if (!profile.twicCardUrl) missing.push("TWIC card photo");
  if (!profile.twicExpiry) missing.push("TWIC expiration date");
  // Optional: future-proof for CCW etc.
  // if (!profile.ccwUrl) missing.push("CCW permit");
  return { ready: missing.length === 0, missing };
}

// Convenience for status-style displays — list each requirement so the UI
// can show ✓/⨯ per row.
export function guardChecklist(profile) {
  return [
    { key: "photoUrl",     label: "Profile photo",      ok: !!profile?.photoUrl },
    { key: "phone",        label: "Phone number",       ok: !!profile?.phone },
    { key: "twicCardUrl",  label: "TWIC card photo",    ok: !!profile?.twicCardUrl },
    { key: "twicExpiry",   label: "TWIC expiration",    ok: !!profile?.twicExpiry },
    // Tax info — soft (won't block grabbing but block payouts)
    { key: "taxName",      label: "Legal name (W9)",    ok: !!profile?.taxName,  soft: true },
    { key: "tin",          label: "Tax ID (W9)",        ok: !!profile?.tin,      soft: true },
    { key: "address",      label: "Mailing address",    ok: !!profile?.address,  soft: true },
  ];
}
